import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GeoLocationService } from './core/services/geolocation.service';
import { CommonService } from './core/services/common.service';
import { ScriptInjectorService } from './core/services/script-injector.service';
import { QueryStringService } from './core/services/query-string.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(private geoLocation: GeoLocationService,
    private commonService: CommonService,
    private qspService: QueryStringService,
    private scriptInjector: ScriptInjectorService
  ) {}

  ngOnInit(): void {
    if(!this.commonService.isPlatformBrowser()) {
       // Inject AB Tasty script if not disabled via query string
      this.scriptInjector.injectABtastyScript();
    }
  }


  ngAfterViewInit(): void {
    if(this.commonService.isPlatformBrowser()) {
      this.geoLocation.setLocation();
      const qsp = this.qspService.getFullQspString();
      if (qsp) {
        this.qspService.appendQspOnCookieBanner();
      }
    }
  }
}
